import React from 'react';
import { Wrapper, AsideLayout, BottomSection, Heading, Section } from './styles.Aside';
import { mainConfig } from '../../../../config/config.provider';
import { Tag } from '../../tag/Tag';
import { Authors } from '../../authors/Authors';

interface AsideProps {
    darkenAside?: boolean;
    background?: string;
}

export const Aside: React.FC<AsideProps> = ({ darkenAside, background }) => {
    return (
        <Wrapper background={'media/header-blur.jpg'}>
            <AsideLayout isDark={darkenAside}>
                <Section>
                    <Heading>Bild</Heading>
                    <div>© BR24</div>
                    <div>Bildrechte: BR24</div>
                </Section>

                <Section>
                    <Heading>Schlagwörter</Heading>
                    {mainConfig.keywords?.map((tag, index) => (
                        <Tag key={`tag-${index}`}>{tag}</Tag>
                    ))}
                </Section>
                <BottomSection>
                    <Heading>Von</Heading>
                    <Authors />
                </BottomSection>
            </AsideLayout>
        </Wrapper>
    );
};
